import React, { useState } from 'react';
import { FaStar, FaMapMarkerAlt, FaHotel } from 'react-icons/fa';
import VillaDetailsPopup from '../popup-containers/VillaDetailsPopup';

const HotelCard = ({ hotel }) => {
  const [showPopup, setShowPopup] = useState(false);

  // Safe array converter
  const toArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;

    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed;
      } catch {
        return value.split(",").map(v => v.trim());
      }
    }

    if (typeof value === "object") {
      return Object.values(value).map(String);
    }

    return [String(value)];
  };

  return (
    <>
      <div className="flex flex-col md:flex-row bg-white shadow-lg rounded-xl overflow-hidden mb-6 hover:shadow-2xl transition">
        <img
          src={hotel.Photo}
          alt={hotel.RoomType}
          className="w-full md:w-48 h-48 object-cover"
        />
        <div className="flex flex-col justify-between p-4 flex-grow">
          <div>
            <h3 className="text-xl font-bold">{hotel.RoomType}</h3>
            <p className="flex items-center text-gray-500 text-sm mt-1">
              <FaMapMarkerAlt className="mr-1 text-green-600" /> {hotel.City}
            </p>
             <p className="flex items-center text-gray-500 text-[12px] mt-1">
              <FaHotel className="mr-1 text-green-600" /> {hotel.PropertyName}
            </p>
            <p className="text-sm mt-2 text-gray-700">
              {toArray(hotel?.Amenities).join(", ")}
            </p>
            <p className="text-sm mt-2 text-yellow-600 font-semibold flex items-center">
              <FaStar className="mr-1" /> {hotel.AvgRating} ({hotel.TotalReviews} reviews)
            </p>
          </div>
          <div className="flex flex-col sm:flex-row justify-between items-center mt-3">
            <p className="text-lg font-bold text-green-700 mb-2 sm:mb-0">
              ₹{hotel.pricePerNight ?? hotel.BaseTariff} / night
            </p>
            <button
              onClick={() => setShowPopup(true)}
              className="bg-green-700 text-white px-4 py-2 rounded w-full sm:w-auto hover:bg-green-800 transition"
            >
              See Details
            </button>
          </div>
        </div>
      </div>

      {/* Villa Details Popup */}
      {showPopup && <VillaDetailsPopup hotel={hotel} onClose={() => setShowPopup(false)} />}
    </>
  );
};

export default HotelCard;
